<div class="page-container">
  <!--full-header></full-header-->
  <div class="contentwrapper">
      <div class="logo-section">
        <img src="./assets/img/zero/logo/zero-brandcard-logo-v.svg">
      </div>
      <router-outlet></router-outlet>
  </div>
  <full-footer></full-footer>
</div>
